import HeaderCell from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/HeaderCell'
import withAlignment, {
  Alignment
} from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/Alignment'
import { VerticalAlignment } from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/Alignment/Alignment'
import {
  Column,
  ColumnType
} from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import { UserRoles } from '@modules/common'
import withCustomField from '@modules/order/components/CellTemplates/CustomFieldHOC'
import NoContent from '@modules/order/components/CellTemplates/NoContent'
import groupBy from 'lodash/groupBy'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import {
  getQuantityKPIColumns,
  getQuantityKPILabels
} from '@modules/order/constants/QuantityHeaderKPI'
import * as css from '@modules/order/stores/view/List/./ListViewTableService.css'
import { config } from '@config'
import { DefaultConfig } from '@constants'
import sortBy from 'lodash/sortBy'
import CNFProductInfo from '@modules/order/components/CellTemplates/ProductInfo/CNFProductInfo'
import EnhancedListProductQuantity from '@modules/showroom/EnhancedOrder/components/EnhancedListView/EnhancedCellTemplates/EnhancedListProductQuantity/EnhancedListProductQuantity'
import ViewSettingStore from '@modules/order/stores/ViewSettingStore'
import EnhancedBookQty from '@modules/showroom/EnhancedOrder/components/EnhancedListView/EnhancedCellTemplates/EnhancedBookQty/EnhancedBookQty'
import { EnhancedQuantity } from '@modules/showroom/EnhancedOrder/components/EnhancedListView/EnhancedCellTemplates/EnhancedQuantity/EnhancedQuantity'
import QuantityHeaderWithKPI from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedQuantitiesWithKPI/QuantityHeaderWithKPI'
import RollUpButton from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedQuantitiesWithKPI/RollUpButton'
import HierarchyQuantityValue from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedHierarchyQuantityValue/HierarchyQuantityValue'
import EnhancedCMClusters from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedClustersColumn/EnhancedCMClusters'
import EnhancedRMClusters from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedClustersColumn/EnhancedRMClusters/EnhancedRMClusters'
import EnhancedHierarchyKPIDetails from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedHierarchyKPIDetails'
import EnhancedListHierarchyHeader from '../../components/EnhancedListView/EnhancedCellTemplates/EnhancedListHierarchyHeader'
import EnhancedProductQuantity from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedProductQuantity'
import EnhancedFieldData from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedFieldData'
import EnhancedCurrency from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedCurrency'
import EnhancedAverageDepth from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedAverageDepth'
import EnhancedAverageWeekSales from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedAverageWeekSales'
import EnhancedNumberFieldData from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedNumberFieldData'
import EnhancedSalesPeriod from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedSalesPeriod'
import EnhancedHierarchyCurrency from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedHierarchyCurrency'
import EnhancedComments from '../../components/EnhancedListView/EnhancedSummaryCell/EnhancedComments'
import classNames from 'classnames'
import {
  getDoorQuantityColumnAttributeId,
  getColumnKeyFromQuantityType,
  getColumnLabelFromQuantityType
} from '@modules/order/utils/table-column-utils'
import EmptyHeaderCell from '@components/UI-Components/HierarchyWiseItemsTable/components/Utils/HeaderCell/EmptyHeaderCell'

export enum ListTableView {
  Quantity = 'Quantity',
  Summary = 'Summary'
}

export const QUANTITIES_AND_BOOK = 'quantitiesAndBook'
export default class EnhancedListViewTableService extends ViewSettingStore {
  commonHeaderClass = `${css['enhancedHeaderCell']} ${css['customBorder']}`
  commonGroupCellClass = classNames(css.groupedCell, 'listViewTableGroupCellOverride')
  getFixedColumns: (productInfoColumnName?) => Column[] = productInfoColumnName => {
    return [
      {
        field: 'name',
        width: 375,
        label: `${productInfoColumnName}`,
        key: '',
        fixed: true,
        showHeader: true,
        allowHide: false,
        showBorders: true,
        cellElement: CNFProductInfo,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          HeaderCell,
          Alignment.LEFT,
          VerticalAlignment.CENTER,
          css['enhancedCellAlignment']
        ),
        hierarchyRowCellTemplate: withAlignment(
          EnhancedListHierarchyHeader,
          Alignment.LEFT,
          VerticalAlignment.CENTER
        )
      }
    ]
  }

  getColumnsForSummaryView() {
    return [
      {
        field: 'clusters',
        width: 150,
        label: 'CM Clusters',
        key: 'clusters',
        attributeId: 'cmClusters',
        showBorders: false,
        cellElement: EnhancedCMClusters,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'rmClusters',
        width: 150,
        label: 'RM Clusters',
        key: 'rmClusters',
        attributeId: 'rmClusters',
        showBorders: false,
        cellElement: EnhancedRMClusters,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.totalByProductQuantity',
        enhancedField: 'clientOrderProductQuantity',
        width: 150,
        label: 'Product Quantity',
        key: 'summary.totalByProductQuantity',
        attributeId: 'totalProductQuantity',
        showBorders: false,
        cellElement: EnhancedProductQuantity,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'totalProductQuantity', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.totalByForecastQuantity',
        enhancedField: 'forecastQuantity',
        attributeId: 'totalForecastQuantity',
        width: 150,
        label: 'Forecast Quantity',
        key: 'summary.totalByForecastQuantity',
        showBorders: false,
        cellElement: EnhancedFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'totalForecastQuantity', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.totalValueByProductQuantity',
        enhancedField: 'clientOrderProductValue',
        width: 150,
        label: 'Product Value',
        key: 'summary.totalValueByProductQuantity',
        attributeId: 'totalProductValue',
        showBorders: false,
        cellElement: EnhancedCurrency,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyCurrency, {
          column: { field: 'totalProductValue', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.totalValueByForecastQuantity',
        enhancedField: 'forecastValue',
        width: 150,
        label: 'Forecast Value',
        key: 'summary.totalValueByForecastQuantity',
        attributeId: 'totalForecastValue',
        showBorders: false,
        cellElement: EnhancedCurrency,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyCurrency, {
          column: { field: 'totalForecastValue', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.totalByDraftQuantity',
        enhancedField: 'doorOrderProductDoorQuantity',
        width: 150,
        label: 'Door Quantity',
        key: 'summary.totalByDraftQuantity',
        attributeId: 'totalDoorQuantity',
        showBorders: false,
        cellElement: EnhancedFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'totalDoorQuantity', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.totalValueByDraftQuantity',
        enhancedField: 'doorOrderProductDoorValue',
        width: 150,
        label: 'Door Value',
        key: 'summary.totalValueByDraftQuantity',
        attributeId: 'totalDoorValue',
        showBorders: false,
        cellElement: EnhancedCurrency,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyCurrency, {
          column: { field: 'totalDoorValue', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.avgWeeklySales',
        enhancedField: 'averageWeeklySales',
        width: 150,
        label: 'Average Week Sales',
        key: 'summary.avgWeeklySales',
        attributeId: 'averageWeeklySales',
        showBorders: false,
        cellElement: EnhancedAverageWeekSales,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'averageWeeklySales', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.forecastAvgWeeklySales',
        enhancedField: 'forecastAverageWeeklySales',
        width: 150,
        label: 'Forecast Avg WK Sales',
        key: 'summary.forecastAvgWeeklySales',
        attributeId: 'forecastAverageWeeklySales',
        showBorders: false,
        cellElement: EnhancedNumberFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'forecastAverageWeeklySales', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.avgDepth',
        enhancedField: 'averageDepth',
        width: 150,
        label: 'Average Depth',
        key: 'summary.avgDepth',
        attributeId: 'averageDepth',
        showBorders: false,
        cellElement: EnhancedAverageDepth,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'averageDepth', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.forecastAvgDepth',
        enhancedField: 'forecastAverageDepth',
        width: 150,
        label: 'Forecast Avg Depth',
        key: 'summary.forecastAvgDepth',
        attributeId: 'forecastAverageDepth',
        showBorders: false,
        cellElement: EnhancedNumberFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'forecastAverageDepth', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.doorProducts',
        enhancedField: 'numberOfStores',
        width: 150,
        label: 'Total Stores',
        key: 'summary.doorProducts',
        attributeId: 'numberOfStores',
        showBorders: false,
        isAlignCenter: false,
        cellElement: EnhancedFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'numberOfStores', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.forecastTotalStores',
        enhancedField: 'forecastNumberOfStores',
        width: 150,
        label: 'Forecast Total Stores',
        key: 'summary.forecastTotalStores',
        attributeId: 'forecastNumberOfStores',
        showBorders: false,
        isAlignCenter: false,
        cellElement: EnhancedFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'forecastNumberOfStores', label: '' }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.salesPeriod',
        enhancedField: 'retailSalesPeriod-name',
        width: 150,
        label: 'Sales Period',
        key: 'summary.salesPeriod',
        attributeId: 'retailSalesPeriod-name',
        showBorders: false,
        cellElement: EnhancedSalesPeriod,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.salesPeriodWeeks',
        enhancedField: 'retailSalesPeriod-numberOfWeeks',
        width: 150,
        label: 'Sales Period Weeks',
        key: 'summary.salesPeriodWeeks',
        attributeId: 'retailSalesPeriod-numberOfWeeks',
        showBorders: false,
        cellElement: EnhancedFieldData,
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.orderProduct.salesQuantity',
        enhancedField: 'salesQuantity',
        width: 150,
        label: 'Sales Quantity',
        key: 'summary.salesQuantity',
        attributeId: 'salesQuantity',
        showBorders: false,
        cellElement: EnhancedNumberFieldData,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: {
            field: 'salesQuantity',
            label: ''
          }
        }),
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.productComments.RM',
        enhancedField: 'rmComments',
        width: 200,
        label: 'RM Comments',
        key: 'productComments.RM',
        attributeId: 'rmComments',
        showBorders: false,
        isAlignCenter: false,
        cellElement: EnhancedComments({
          commentType: 'RM',
          allowedUserRoles: [UserRoles.REGIONAL_MERCHANDISER]
        }),
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true,
        className: this.commonHeaderClass
      },
      {
        field: 'summary.productComments.CM',
        enhancedField: 'cmComments',
        width: 200,
        label: 'CM Comments',
        key: 'productComments.CM',
        attributeId: 'cmComments',
        showBorders: false,
        isAlignCenter: false,
        cellElement: EnhancedComments({
          commentType: 'CM',
          allowedUserRoles: []
        }),
        hierarchyRowCellTemplate: NoContent,
        allowReordering: true,
        className: css['enhancedHeaderCell']
      }
    ] as Column[]
  }

  getColumnsForQtyView(
    captureSize: boolean,
    isValueSelected?: boolean,
    quantityType?: string,
    kpiLabels?: any[]
  ) {
    return [
      {
        field: 'quantity.totalByProductQuantity',
        enhancedField: 'clientOrderProductQuantity',
        width: 160,
        label: 'Product Quantity',
        key: 'quantity.totalByProductQuantity',
        attributeId: 'totalProductQuantity',
        showBorders: true,
        fixed: true,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          RollUpButton(),
          Alignment.LEFT,
          VerticalAlignment.CENTER,
          this.commonGroupCellClass
        ),
        cellElement: EnhancedListProductQuantity,
        cellAlignment: false,
        hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
          column: { field: 'totalProductQuantity', label: '' }
        })
      },
      {
        field: QUANTITIES_AND_BOOK,
        width: 150,
        label: getColumnLabelFromQuantityType(quantityType, captureSize, isValueSelected),
        key: getColumnKeyFromQuantityType(quantityType, captureSize, isValueSelected),
        fixed: true,
        attributeId: getDoorQuantityColumnAttributeId(quantityType, isValueSelected),
        showBorders: false,
        isStickyBorder: true,
        showHeaderRightBorder: !!kpiLabels?.length,
        cellElement: EnhancedBookQty,
        headerCellElement: kpiLabels?.length
          ? withAlignment(
              QuantityHeaderWithKPI({ headers: kpiLabels, doorOrderId: null }),
              Alignment.LEFT,
              VerticalAlignment.CENTER,
              this.commonGroupCellClass
            )
          : withAlignment(
              EmptyHeaderCell({ showBorder: true }),
              Alignment.CENTER,
              VerticalAlignment.CENTER,
              this.commonGroupCellClass
            ),
        cellAlignment: false,
        hierarchyRowCellTemplate: HierarchyQuantityValue
      }
    ] as Column[]
  }

  getColumnsForQtyViewForRetail(
    captureSize: boolean,
    isValueSelected?: boolean,
    quantityType?: string,
    kpiLabels?: any[]
  ) {
    return [
      {
        field: 'rmClusters',
        width: 150,
        label: 'RM Clusters',
        key: 'rmClusters',
        attributeId: 'rmClusters',
        showBorders: true,
        fixed: true,
        cellElement: EnhancedRMClusters,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          HeaderCell,
          Alignment.CENTER,
          VerticalAlignment.CENTER,
          css['enhancedCellAlignment']
        ),
        hierarchyRowCellTemplate: NoContent
      },
      {
        field: 'clusters',
        width: 150,
        label: 'CM Clusters',
        key: 'clusters',
        attributeId: 'cmClusters',
        showBorders: true,
        cellElement: EnhancedCMClusters,
        className: css.headerPosition,
        headerCellElement: withAlignment(
          HeaderCell,
          Alignment.CENTER,
          VerticalAlignment.CENTER,
          css['enhancedCellAlignment']
        ),
        hierarchyRowCellTemplate: NoContent
      },
      ...((config.displayAvgDepthAndTotalStoresInQtyView ||
        DefaultConfig.DISPLAY_AVG_DEPTH_AND_TOTAL_STORES_IN_QTY_VIEW) === 'true'
        ? [
            {
              field: 'quantity.avgDepth',
              enhancedField: 'averageDepth',
              width: 140,
              label: 'Average Depth',
              key: 'quantity.avgDepth',
              attributeId: 'averageDepth',
              showBorders: true,
              className: css.headerPosition,
              headerCellElement: withAlignment(
                HeaderCell,
                Alignment.CENTER,
                VerticalAlignment.CENTER,
                css['enhancedCellAlignment']
              ),
              cellElement: EnhancedAverageDepth,
              hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
                column: { field: 'averageDepth', label: '' }
              })
            },
            {
              field: 'quantity.doorProducts',
              enhancedField: 'numberOfStores',
              width: 140,
              label: 'Total Stores',
              key: 'quantity.doorProducts',
              attributeId: 'numberOfStores',
              className: css.headerPosition,
              showBorders: true,
              cellElement: EnhancedFieldData,
              headerCellElement: withAlignment(
                HeaderCell,
                Alignment.CENTER,
                VerticalAlignment.CENTER,
                css['enhancedCellAlignment']
              ),
              hierarchyRowCellTemplate: withCustomField(EnhancedHierarchyKPIDetails, {
                column: { field: 'numberOfStores', label: '' }
              })
            }
          ]
        : []),
      ...this.getColumnsForQtyView(captureSize, isValueSelected, quantityType, kpiLabels)
    ] as Column[]
  }

  getColumnForDoor(
    doorOrder: any,
    quantityKPIS: any[],
    allowReordering: boolean,
    quantityKPILabels: any[],
    doorOrdersLength?
  ) {
    return {
      field: doorOrder.door.id,
      label: doorOrder.door.name,
      width: 150,
      allowHide: true,
      showBorders: false,
      allowReordering,
      headerCellElement: quantityKPILabels?.length
        ? withAlignment(
            QuantityHeaderWithKPI({
              headers: quantityKPIS,
              doorOrderId: doorOrder.door.id
            }),
            Alignment.LEFT,
            VerticalAlignment.CENTER,
            doorOrdersLength ? this.commonGroupCellClass : css.groupedCell
          )
        : withAlignment(
            EmptyHeaderCell({ showBorder: false }),
            Alignment.CENTER,
            VerticalAlignment.CENTER,
            this.commonGroupCellClass
          ),
      cellElement: EnhancedQuantity,
      cellAlignment: false,
      hierarchyRowCellTemplate: HierarchyQuantityValue
    } as Column
  }

  getClusteredDoors(
    doorOrders: any[],
    quantityKPIS: any[],
    hiddenTotalKpiRows: any[],
    quantityKPILabels?: any[]
  ) {
    const groupedDoors = groupBy(
      sortBy(doorOrders, ['door.sortOrder', 'door.name']),
      'door.cluster.id'
    )
    return Object.keys(groupedDoors)
      .sort(
        (clusterId1, clusterId2) =>
          groupedDoors[clusterId1][0].door.cluster.sortOrder -
          groupedDoors[clusterId2][0].door.cluster.sortOrder
      )
      .map(clusterId => ({
        field: clusterId,
        label: hiddenTotalKpiRows?.includes('clusterName')
          ? ''
          : groupedDoors[clusterId][0].door.cluster.name || 'Unclustered',
        filterSubColumns: true,
        showHeader: !hiddenTotalKpiRows?.includes('clusterName'),
        allowHide: true,
        showBorders: true,
        allowReordering: true,
        type: ColumnType.Grouped,
        columns: groupedDoors[clusterId]
          .sort(
            (doorOrder1, doorOrder2) =>
              doorOrder1.door.sortOrder - doorOrder2.door.sortOrder
          )
          .map(doorOrder =>
            this.getColumnForDoor(doorOrder, quantityKPIS, true, quantityKPILabels)
          ),
        cellElement: EnhancedQuantity
      })) as Column[]
  }

  getColumns: (
    doorOrders: any[],
    groupedDoors?: boolean,
    captureSize?: boolean,
    isValueSelected?: boolean,
    quantityType?: string,
    productInfoColumnName?: string,
    hiddenTotalKpiRows?: any[],
    tableSettingRows?: any
  ) => Column[] = (
    doorOrders,
    groupedDoors,
    captureSize,
    isValueSelected,
    quantityType,
    productInfoColumnName,
    hiddenTotalKpiRows = [],
    tableSettingRows = {}
  ) => {
    const doorOrdersLength = doorOrders?.length
    const retailKPILabels = getQuantityKPILabels(
      quantityType,
      VIPChannel.Retail,
      hiddenTotalKpiRows,
      tableSettingRows
    )
    const wholesaleKPILabels = getQuantityKPILabels(
      quantityType,
      VIPChannel.Wholesale,
      hiddenTotalKpiRows,
      tableSettingRows
    )
    return [
      ...this.getFixedColumns(productInfoColumnName),
      ...(doorOrders?.length
        ? groupedDoors
          ? [
              ...this.getColumnsForQtyViewForRetail(
                captureSize,
                isValueSelected,
                quantityType,
                retailKPILabels
              ),
              ...this.getClusteredDoors(
                doorOrders,
                getQuantityKPIColumns(
                  quantityType,
                  VIPChannel.Retail,
                  hiddenTotalKpiRows,
                  tableSettingRows
                ),
                hiddenTotalKpiRows,
                retailKPILabels
              )
            ]
          : [
              ...this.getColumnsForQtyView(
                captureSize,
                isValueSelected,
                quantityType,
                wholesaleKPILabels
              ),
              ...doorOrders
                .sort(
                  (doorOrder1, doorOrder2) =>
                    doorOrder1.door.sortOrder - doorOrder2.door.sortOrder
                )
                .map(doorOrder =>
                  this.getColumnForDoor(
                    doorOrder,
                    getQuantityKPIColumns(
                      quantityType,
                      VIPChannel.Wholesale,
                      hiddenTotalKpiRows,
                      tableSettingRows
                    ),
                    false,
                    wholesaleKPILabels,
                    doorOrdersLength
                  )
                )
            ]
        : this.getColumnsForSummaryView())
    ]
  }
}
